import { Suspense, useEffect, useState } from 'react';
import { Router } from 'react-router-dom';

import LocalizationProvider from '@guestyci/localize/LocalizationProvider';
import ToastProvider from '@guestyci/foundation/Toast';

import AppNavBar from '~/layout/AppNavBar';
import DirtyWarningDialog from '~/layout/components/DirtyWarningDialog';

import AppSpinner from 'components/AppSpinner';
import { initFeatureToggle, initMoment } from 'init';
import AppRoutes from 'routes/AppRoutes';
import { getMatchingRoute } from 'routes/routes';
import { useAppSelector } from 'store';
import { initDataDog } from 'utils/datadog';
import localStorage from 'utils/localStorage';
import { getNormalizedLocale } from 'utils/owner';

const App = ({ history }) => {
  const userLocale = useAppSelector((state) => state.user.locale);
  const route = getMatchingRoute(window.location.pathname);

  const isFetching = useAppSelector(
    (state) => route?.isFetching(state) || state.ui.shouldDisplayLoader
  );
  const [isFeatureToggleInitialized, setIsFeatureToggleInitialized] =
    useState(false);

  useEffect(() => {
    initDataDog();
    initFeatureToggle().then(() => setIsFeatureToggleInitialized(true));
    initMoment('en-US');
  }, []);

  useEffect(() => {
    if (userLocale) {
      initMoment(userLocale);
    }

    localStorage.setLanguage(getNormalizedLocale(userLocale));
  }, [userLocale]);

  if (isFetching || !isFeatureToggleInitialized) {
    return <AppSpinner />;
  }

  return (
    <LocalizationProvider language={getNormalizedLocale(userLocale)}>
      <ToastProvider>
        <div id="app" className="main">
          <Suspense fallback={<AppSpinner />}>
            <Router history={history}>
              <AppNavBar />

              <AppRoutes />

              <DirtyWarningDialog />
            </Router>
          </Suspense>
        </div>
      </ToastProvider>
    </LocalizationProvider>
  );
};

export default App;
